<template lang="pug">
    div
        div(class="vid-image relative leading-none")
            slot
                img(
                    v-bind="videoThumbNailProps"
                    class="cursor-pointer"
                    :alt="video.title"
                    loading="lazy"
                )
            div(class="playButton absolute w-16 h-10 m-auto top-0 right-0 bottom-0 left-0 bg-gray opacity-75 transition-all duration-100 ease-in-out")
            div(class="play-triangle absolute m-auto top-0 right-0 bottom-0 left-0 w-4 h-5 border-left-4 bo")
        div(v-if="video.title" class="mt-2 text-xs md:text-sm")
            div(v-html="video.title" class="text-gray-darkest font-bold")
            div(v-if="video.duration" class="text-gray-dark")
                | {{ durationToClock(video.duration) }}

        VideoSchema(:video="video")
</template>

<script>
import VideoSchema from '@/components/videoSchema.vue'
import { durationToClock } from '@/helpers/filters'

export default {
    components: {
        VideoSchema,
    },
    props: {
        video: {
            type: Object,
            required: true,
        },
        hiRes: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        thumbSize() {
            return {
                filename: this.hiRes ? 'maxresdefault.jpg' : 'mqdefault.jpg',
                width: this.hiRes ? 1280 : 320,
                height: this.hiRes ? 720 : 180,
            }
        },
        videoThumbNailProps() {
            let thumbUrl = ''
            if (this.video.thumbnail)
                thumbUrl = this.$getImageUrl(
                    this.video.thumbnail.key,
                    this.video.thumbnail.filename,
                    320,
                    180
                )
            else if (this.video.type === 'YOUTUBE')
                thumbUrl = `//img.youtube.com/vi/${this.video.id}/${this.thumbSize.filename}`
            else thumbUrl = this.$getImagePlaceholder(320, 180)
            return {
                src: thumbUrl,
                class: `${this.video.type.toLowerCase()}-thumbnail`,
                width: this.thumbSize.width,
                height: this.thumbSize.height,
            }
        },
    },
    methods: {
        durationToClock,
    },
}
</script>

<style lang="stylus" scoped>
.vid-image
    &:hover
        .playButton
            width 100%
            height 100%
            background-color theme('colors.black')
            opacity .35
            cursor pointer
.play-triangle
    border-left solid 14px $white
    border-bottom solid 10px transparent
    border-top solid 10px transparent
</style>
